export const GET_REMITTANCE_PAYOUT_CYCLE_REQUEST = "GET_REMITTANCE_PAYOUT_CYCLE_REQUEST";
export const GET_REMITTANCE_PAYOUT_CYCLE_SUCCESS = "GET_REMITTANCE_PAYOUT_CYCLE_SUCCESS";
export const GET_REMITTANCE_PAYOUT_CYCLE_FAILURE = "GET_REMITTANCE_PAYOUT_CYCLE_FAILURE";
export const GET_REMITTANCE_PAYOUT_CYCLE_RESET = "GET_REMITTANCE_PAYOUT_CYCLE_RESET";
export const getRemittancePayoutCycleRequest = (payload) => ({
    type: GET_REMITTANCE_PAYOUT_CYCLE_REQUEST,
    payload,
});
export const getRemittancePayoutCycleSuccess = (payload) => ({
    type: GET_REMITTANCE_PAYOUT_CYCLE_SUCCESS,
    payload,
});
export const getRemittancePayoutCycleFailure = (payload) => ({
    type: GET_REMITTANCE_PAYOUT_CYCLE_FAILURE,
    payload,
});
export const getRemittancePayoutCycleReset = () => ({
    type: GET_REMITTANCE_PAYOUT_CYCLE_RESET,
});
